import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map ,switchMap} from 'rxjs';
import { EncryptionService } from '../helpers/encryption-service.service'

@Injectable()
export class EncryptionInterceptor implements HttpInterceptor {
  constructor(private encryptionService: EncryptionService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Check if the request URL requires encryption
    
  //   if (req.url.includes('UpdateFacilityMemberProfile')
  //   || req.url.includes('CreateCase')
  // ||req.url.includes('GetAllCases')
  // ) {
  
  //     const encryptedBody = this.encryptionService.encryptPayload(req.body);
  //     const encryptedReq = req.clone({ body: encryptedBody });
  //     return next.handle(encryptedReq).pipe(
  //       switchMap((event: HttpEvent<any>) => this.handleResponse(event, req))
  //     );
  //   }

    return next.handle(req).pipe(
      switchMap((event: HttpEvent<any>) => this.handleResponse(event, req))
    );
  }
  private checkRequestMasking(req:any, key:any) {
    return req.url?.toLowerCase()?.includes(key?.toLowerCase()) || (typeof req.body === 'object' && req.body !== null && Object.hasOwn(req.body, 'url' ) && req.body?.url?.toLowerCase()?.includes(key?.toLowerCase()))
  }

  private handleResponse(event: HttpEvent<any>, req: HttpRequest<any>): Observable<HttpEvent<any>> {
    if (event instanceof HttpResponse) {
      if (
          (this.checkRequestMasking(req,'GetCaseById') && !req.url.includes('GetCaseById_CDD'))
          ||
          this.checkRequestMasking(req,'GetAllCases')||
          (this.checkRequestMasking(req,'SubmitStage') && localStorage.getItem('healthCareFacilityId'))||
          // this.checkRequestMasking(req,'PersonalProfileDetail') ||
          this.checkRequestMasking(req,'GetFacilityMemberProfileByID') ||
          this.checkRequestMasking(req,'GetAllFacilityMemberProfile') ||
          this.checkRequestMasking(req,'UAEPassCallback') ||
          this.checkRequestMasking(req,"facilitymemberprofile/authenticate")
        ) {
            
        const responseBody = event.body;
          
        if (responseBody && responseBody.result) {
          const decryptedResult = this.encryptionService.decryptPayload(responseBody.result);
          responseBody.result = decryptedResult;
        }

        return new Observable<HttpEvent<any>>(observer => {
          observer.next(event.clone({ body: responseBody }));
          observer.complete();
        });
      }
    }
    return new Observable<HttpEvent<any>>(observer => {
      observer.next(event);
      observer.complete();
    });
  }
}
